module.exports = __webpack_public_path__ + "static/media/ice@2x.4689d785.png";